/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_item = {
    readonly isAvailable: boolean | null;
    readonly isSold: boolean | null;
    readonly hasPrivateListing: boolean | null;
    readonly hasActiveHoldForBuyer?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailItemInvoice_item">;
    readonly " $refType": "PdpSharedDetailReference_item";
};
export type PdpSharedDetailReference_item$data = PdpSharedDetailReference_item;
export type PdpSharedDetailReference_item$key = {
    readonly " $data"?: PdpSharedDetailReference_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReference_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "hasActiveHoldForBuyer",
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '3541a2cc60241d4a15f767e093e71305';
export default node;
